/**
 * @voltxampere/ui — TLP521 quad optocoupler (Sprint 44-4, placeholder)
 *
 * PLACEHOLDER. Quad (4-channel) phototransistor opto — single
 * DIP-16 paketinde 4 bağımsız izole channel. Endüstriyel I/O
 * board, multi-channel relay drive, PLC giriş izolasyonu.
 *
 * Reference: Toshiba TLP521-4 — DIP-16. V_F = 1.15 V, V_R = 5 V,
 * I_F = 50 mA per channel, CTR = 50-300% (range). 4 channel
 * isolation single package.
 *
 * Engine zero-diff invariant honored — canonical `led` engine type
 * via schemaType (single channel input shown; quad-package
 * multi-channel layout Sprint 47+'da composition).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const optoTlp521 = {
    id: "tlp521",
    nameTr: "TLP521 (Quad Opto Toshiba, DIP-16, placeholder)",
    nameEn: "TLP521 (Quad Opto Toshiba, DIP-16, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "U",
    defaultValue: "TLP521",
    schemaType: "led",
    defaultParams: { saturationCurrent: 1e-12, ideality: 2 },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=opto-tlp521.js.map